interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
    handleClick?: () => void;
}

export const SearchIcon = ({
    width = 20,
    height = 20,
    hexColor = 'black',
    handleClick
}: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default SearchIcon;
